import { createRpcBackend } from "@/backend/backendProvider";

export class AlmConfigurationHandler {
  constructor(context) {
    this.backend = createRpcBackend(context);
  }

  getAlmConnections() {
    return this.backend.almCall("get_alm_connections");
  }

  getAlmTools() {
    return this.backend.almCall("get_alm_tools");
  }

  getAlmConfiguration(sessionId) {
    return this.backend.almCall("get_session_info", [sessionId]);
  }

  createAlmConnection(almType) {
    return this.backend.almCall("create_alm_connection", [almType]);
  }
}
